import { render, staticRenderFns } from "./BodyInfoEntry.vue?vue&type=template&id=c5b283c6&scoped=true"
import script from "./BodyInfoEntry.vue?vue&type=script&lang=js"
export * from "./BodyInfoEntry.vue?vue&type=script&lang=js"
import style0 from "./BodyInfoEntry.vue?vue&type=style&index=0&id=c5b283c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b283c6",
  null
  
)

export default component.exports